import API from "./API";
import axios from "axios";

const Study = {

    async getCourse(id){
        const url = API.url(`/study/courses/${id}`);
        const response = await axios.get(url);
        return response;
    },

    async getMyEnrollments(){
        const url = API.url(`/study/enrollments`);
        const response = await axios.get(url);
        return response;
    },

    async getSection(id){
        const url = API.url(`/study/sections/${id}`);
        const response = await axios.get(url);
        return response;
    },

    async getView(id, view){
        const url = API.url(`/study/enrollments/${id}/views/${view}`);
        return await axios.get(url);
    },

    async getHtml(section){
        const url = API.url(`/study/sections/${section.id}/html/${section.slug}.html`);
        return await axios.get(url);
    },

    async getPdf(section){
        const url = API.url(`/study/sections/${section.id}/pdf/${section.slug}.pdf`);
        return await axios({url: url, method: 'GET', responseType: 'blob'});
    },

    async downloadPdf(section){
        const url = API.url(`/study/sections/${section.id}/pdf/${section.slug}.pdf`);
        return await API.downloadFile(url, section.slug + '.pdf');
    },

    async getQuiz(sectionId){
        const url = API.url(`/study/sections/${sectionId}/quiz`);
        return await axios.get(url);
    },

    async getAssessment(enrollmentId, position){
        const url = API.url(`/study/assessments/${enrollmentId}/${position}`);
        return await axios.get(url);
    },

    async postAssessment(data){
        const url = API.url(`/study/assessments/${data.enrollment.id}/${data.position}`);
        return await axios.post(url, data);
    },

    async downloadZip(section){
        const url = API.url(`/study/sections/${section.id}/zip/${section.slug}.zip`);
        return await API.downloadFile(url, section.slug + '.zip');
    },

    async completeSection(courseId, data){
        let url = API.url(`/study/courses/${courseId}/sections/complete`);
        const r = await axios.post(url, data);
        console.log(r.data);
        return r;
    },

    async getReview(courseId){
        const url = API.url(`/study/courses/${courseId}/review`);
        return await axios.get(url);
    },

    async postReview(data){
        const url = API.url(`/study/reviews`);
        return await axios.post(url, data);
    },

    async putReview(data){
        const url = API.url(`/study/reviews/${data.id}`);
        return await axios.put(url, data);
    },

    async getNote(id){
        const url = API.url(`/study/sections/${id}/note`);
        return await axios.get(url);
    },

    async postNote(sectionId, data){
        const url = API.url(`/study/sections/${sectionId}/note`);
        return await axios.post(url, data);
    },

    async timeEnrollment(id, seconds){
        const url = API.url(`/study/enrollments/${id}/time/${seconds}`);
        return await axios.get(url);
    },

    async getEpp(id){
        const url = API.url(`/study/courses/${id}/epp`);
        return await axios.get(url);
    },

    async postEpp(id, data){
        const url = API.url(`/study/courses/${id}/epp`);
        return await axios.post(url, data);
    },

    async downloadDoc(id, name){
        const url = API.url(`/study/enrollments/${id}/${name}/doc.pdf`);
        return await API.downloadFile(url, name + '.pdf');
    },

    pdfUrl(section){
        return API.url(`/study/sections/${section.id}/pdf/${section.slug}.pdf`);
    }

}

export default Study;